import { createUseStyles } from "react-jss";

export default createUseStyles ( theme => ( {
	wrapper: {
		width           : "100%",
		display         : "flex",
		flexDirection   : "column",
		backgroundColor : theme.colors.background.secondary
	}
} ) );
